import React from 'react';

const SplashScreen = () => {

    return (
        <div className="splash-screen">
            <div className="logo-hold">
                <img src='/images/logos/logo-light-no-icon.svg' alt="Logo" className="logo-image" />
            </div>
        </div>
    )

};

export default SplashScreen;



// WEBPACK FOOTER //
// src/client/components/dashboardNew/objects/SplashScreen.js